<template>
  <main class="container py-4">
    <h1 class="h3 mb-2">Self-hosted 3D Viewer</h1>
    <p class="text-muted mb-3">
      Lokales Modell: <code>/models/AW.10.72/model.glb</code> — Orbit / Pan / Zoom wie SketchUp.
    </p>
    <ModelViewer3d src="/models/AW.10.72/model.glb" :height="640" />
    <p class="mt-3 small text-muted">
      LMB = Orbit · RMB = Pan · Scroll = Zoom · Toolbar links: Extents / Reset / Axes / Shadows
    </p>
  </main>
</template>

<script>
import ModelViewer3d from '~/components/ModelViewer3d.vue'

export default {
  name: 'Model3dDemo',
  components: {
    ModelViewer3d
  }
}
</script>
